import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobsTrafficSplitEligibility } from '../reducers/jobs-traffic-split';
import {
    getJobsTrafficSplitResult,
    type JobsTrafficSplitDestination,
    type JobsTrafficSplitResult,
} from '../util/jobs-traffic-split';

type State = {
    baseConfig?: {
        buyerUrl?: string;
    };
    jobsTrafficSplit?: {
        status?: 'idle' | 'loading' | 'loaded';
        eligible?: boolean;
    };
};

export function useJobsTrafficSplitResult(
    fallbackUrl: string,
    destination?: JobsTrafficSplitDestination
): JobsTrafficSplitResult {
    const dispatch = useDispatch();
    const { buyerUrl, eligible, status } = useSelector((state: State) => ({
        buyerUrl: state.baseConfig?.buyerUrl,
        eligible: state.jobsTrafficSplit?.eligible === true,
        status: state.jobsTrafficSplit?.status ?? 'idle',
    }));

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchJobsTrafficSplitEligibility() as any);
        }
    }, [dispatch, status]);

    return getJobsTrafficSplitResult({ buyerUrl, eligible, fallbackUrl, destination });
}

export function useJobsTrafficSplitUrl(
    fallbackUrl: string,
    destination?: JobsTrafficSplitDestination
): string {
    return useJobsTrafficSplitResult(fallbackUrl, destination).url;
}
